import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsLinkComponent } from './google-maps-link.component';

@NgModule({
  declarations: [GoogleMapsLinkComponent],
  imports: [CommonModule],
  exports: [GoogleMapsLinkComponent],
})
export class GoogleMapsLinkModule {}
